import React from "react";

export const SectionTitle = ({ kicker, title, dark = false }) => (
  <div className="mb-12">
    {kicker && <div className={`overline ${dark ? "text-white/60" : "text-[#5E6470]"}`}>{kicker}</div>}
    <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight ${dark ? "text-white" : "text-[#0F1B2D]"}`}>
      {title}
    </h2>
    <span className="gold-rule mt-6 block" />
  </div>
);

export const TaglineLines = ({ text }) =>
  text.split(". ").map((line, i, arr) => (
    <span key={line} className="block">
      {line}{i < arr.length - 1 ? "." : ""}
    </span>
  ));
